export default "__VITE_ASSET__C989dft2__"